import React, { FC, useState, useEffect } from 'react';
import AssignmentList from '@pages/RequestsDetailsPage/components/QuotationManagement/components/LineItemAssignment/components/AssignmentList';
import AssignmentOverview from '@pages/RequestsDetailsPage/components/QuotationManagement/components/LineItemAssignment/components/AssignmentOverview';
import { ILineItemCurrency, ILineItemsData, ISelectedItems } from '@common/interfaces/Common';
import { IProviderLineItem } from '@common/interfaces';
import getData from '@pages/RequestsDetailsPage/components/QuotationManagement/components/LineItemAssignment/utils';
import { sortBy } from 'lodash';

interface IProps {
  data?: IProviderLineItem;
  currencies: ILineItemCurrency;
  selectedLineItems: ISelectedItems;
  setSelectedLineItems: React.Dispatch<React.SetStateAction<ISelectedItems>>;
}

const LineItemAssignment: FC<IProps> = ({
  data,
  currencies,
  selectedLineItems,
  setSelectedLineItems,
}) => {
  const [assignmentData, setAssignmentData] = useState<ILineItemsData[]>();

  useEffect(() => {
    if (data) {
      setAssignmentData(getData(data));
    }
  }, [data]);

  return (
    <div>
      <AssignmentList
        selectedLineItems={selectedLineItems}
        setSelectedLineItems={setSelectedLineItems}
        data={assignmentData ?? []}
        currencies={currencies}
      />
      <AssignmentOverview
        selectedLineItems={selectedLineItems}
        data={sortBy(assignmentData, ['order'], ['asc']) ?? []}
        currencies={currencies}
      />
    </div>
  );
};

export default LineItemAssignment;
